import React from 'react';
import { FaRobot } from 'react-icons/fa';

function PostList({ posts, onSelectPost }) {
  return (
    <div
      style={{
        backgroundColor: '#f3f6f8',
        minHeight: '100vh',
        padding: '2rem 0',
        display: 'flex',
        justifyContent: 'center'
      }}
    >
      <div
        style={{
          width: '100%',
          maxWidth: '700px',
          backgroundColor: '#ffffff',
          padding: '2rem',
          borderRadius: '12px',
          boxShadow: '0 4px 8px rgba(0,0,0,0.05)'
        }}
      >
        <h3 style={{ fontSize: '1.6rem', fontWeight: '700', marginBottom: '1rem' }}>All Posts</h3>
        {posts.length === 0 ? (
          <p>No posts yet. Be the first to create one!</p>
        ) : (
          posts.map((post) => (
            <div
              key={post._id}
              style={{
                display: 'flex',
                gap: '1rem',
                border: '1px solid #e0e0e0',
                borderRadius: '8px',
                padding: '1rem',
                marginBottom: '1.5rem',
                backgroundColor: '#fff',
                alignItems: 'flex-start'
              }}
            >
              {post.mediaUrl && post.mediaType.startsWith('image') && (
                <img
                  src={post.mediaUrl}
                  alt="Post media"
                  style={{
                    width: '100px',
                    height: '100px',
                    objectFit: 'cover',
                    borderRadius: '6px',
                    flexShrink: 0
                  }}
                />
              )}

              {post.mediaUrl && post.mediaType.startsWith('video') && (
                <video
                  controls
                  style={{
                    width: '100px',
                    height: '100px',
                    objectFit: 'cover',
                    borderRadius: '6px',
                    flexShrink: 0
                  }}
                >
                  <source src={post.mediaUrl} type={post.mediaType} />
                </video>
              )}

              <div style={{ flex: 1 }}>
                <h4 style={{ fontSize: '1.2rem', marginBottom: '0.25rem' }}>{post.title}</h4>
                <p style={{ fontSize: '0.85rem', color: '#666', marginBottom: '0.25rem' }}>
                  Posted by <strong>{post.authorName || 'User'}</strong>
                </p>
                <p style={{ fontSize: '0.95rem', color: '#444', marginBottom: '0.5rem' }}>
                  {post.content.substring(0, 150)}...
                </p>

                {post.botReply && (
                  <div
                    style={{
                      marginBottom: '0.75rem',
                      padding: '0.5rem',
                      backgroundColor: '#f1f7ff',
                      borderRadius: '6px',
                      border: '1px solid #cce0ff'
                    }}
                  >
                    <strong style={{ fontSize: '0.85rem' }}>
                      <FaRobot className="robot-icon" /> Reply from TJG Bot
                    </strong>
                    <p style={{ marginTop: '0.25rem', fontSize: '0.85rem' }}>
                      {post.botReply}
                    </p>
                  </div>
                )}

                <button
                  onClick={() => onSelectPost(post._id)}
                  style={{
                    padding: '0.4rem 0.8rem',
                    backgroundColor: '#0a66c2',
                    color: '#fff',
                    border: 'none',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    fontSize: '0.85rem'
                  }}
                >
                  View Post
                </button>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

export default PostList;








// import React from 'react';
// import { FaRobot } from 'react-icons/fa';

// function PostList({ posts, onSelectPost }) {
//   return (
//     <div
//       style={{
//         backgroundColor: '#f3f6f8',
//         minHeight: '100vh',
//         padding: '2rem 0',
//         display: 'flex',
//         justifyContent: 'center'
//       }}
//     >
//       <div
//         style={{
//           width: '100%',
//           maxWidth: '700px',
//           backgroundColor: '#ffffff',
//           padding: '2rem',
//           borderRadius: '12px',
//           boxShadow: '0 4px 8px rgba(0,0,0,0.05)'
//         }}
//       >
//         <h3 style={{ fontSize: '1.6rem', fontWeight: '700', marginBottom: '1rem' }}>All Posts</h3>
//         {posts.length === 0 ? (
//           <p>No posts yet. Be the first to create one!</p>
//         ) : (
//           posts.map((post) => (
//             <div
//               key={post._id}
//               style={{
//                 display: 'flex',
//                 gap: '1rem',
//                 border: '1px solid #e0e0e0',
//                 borderRadius: '8px',
//                 padding: '1rem',
//                 marginBottom: '1.5rem',
//                 backgroundColor: '#fff',
//                 alignItems: 'flex-start'
//               }}
//             >
//               {/* Small media preview */}
//               {post.mediaUrl && post.mediaType.startsWith('image') && (
//                 <img
//                   src={post.mediaUrl}
//                   alt="Post media"
//                   style={{
//                     width: '100px',
//                     height: '100px',
//                     objectFit: 'cover',
//                     borderRadius: '6px',
//                     flexShrink: 0
//                   }}
//                 />
//               )}

//               {post.mediaUrl && post.mediaType.startsWith('video') && (
//                 <video
//                   controls
//                   style={{
//                     width: '100px',
//                     height: '100px',
//                     objectFit: 'cover',
//                     borderRadius: '6px',
//                     flexShrink: 0
//                   }}
//                 >
//                   <source src={post.mediaUrl} type={post.mediaType} />
//                 </video>
//               )}

//               {/* Post content */}
//               <div style={{ flex: 1 }}>
//                 <h4 style={{ fontSize: '1.2rem', marginBottom: '0.5rem' }}>{post.title}</h4>
//                 <p style={{ fontSize: '0.95rem', color: '#444', marginBottom: '0.5rem' }}>
//                   {post.content.substring(0, 150)}...
//                 </p>

//                 {/* Display backend-saved botReply */}
//                 {post.botReply && (
//                   <div
//                     style={{
//                       marginBottom: '0.75rem',
//                       padding: '0.5rem',
//                       backgroundColor: '#f1f7ff',
//                       borderRadius: '6px',
//                       border: '1px solid #cce0ff'
//                     }}
//                   >
//                     <strong style={{ fontSize: '0.85rem' }}><FaRobot className="robot-icon"/>Reply from TJG Bot</strong>
//                     <p style={{ marginTop: '0.25rem', fontSize: '0.85rem' }}>
//                       {post.botReply}
//                     </p>
//                   </div>
//                 )}

//                 <button
//                   onClick={() => onSelectPost(post._id)}
//                   style={{
//                     padding: '0.4rem 0.8rem',
//                     backgroundColor: '#0a66c2',
//                     color: '#fff',
//                     border: 'none',
//                     borderRadius: '4px',
//                     cursor: 'pointer',
//                     fontSize: '0.85rem'
//                   }}
//                 >
//                   View Post
//                 </button>
//               </div>
//             </div>
//           ))
//         )}
//       </div>
//     </div>
//   );
// }

// export default PostList;






// import React, { useEffect, useState } from 'react';
// import axios from 'axios';

// function PostList({ posts, onSelectPost }) {
//   const [botResponses, setBotResponses] = useState({}); // store bot replies keyed by postId

//   useEffect(() => {
//     posts.forEach((post) => {
//       const trimmed = post.content.trim();
//       if ((trimmed.endsWith('?') || trimmed.endsWith('.')) && !botResponses[post._id]) {
//         fetchBotReply(post._id, trimmed);
//       }
//     });
//   }, [posts]);

//   const fetchBotReply = async (postId, prompt) => {
//     try {
//       const res = await axios.post(`${process.env.REACT_APP_API}/`, {
//         text: prompt,
//         from: 'auto-forum-list',
//         sessionId: 'auto-list-bot'
//       });
//       setBotResponses((prev) => ({ ...prev, [postId]: res.data.response }));
//     } catch (err) {
//       console.error('Bot auto-comment failed for list:', err);
//     }
//   };

//   return (
//     <div
//       style={{
//         backgroundColor: '#f3f6f8',
//         minHeight: '100vh',
//         padding: '2rem 0',
//         display: 'flex',
//         justifyContent: 'center'
//       }}
//     >
//       <div
//         style={{
//           width: '100%',
//           maxWidth: '700px',
//           backgroundColor: '#ffffff',
//           padding: '2rem',
//           borderRadius: '12px',
//           boxShadow: '0 4px 8px rgba(0,0,0,0.05)'
//         }}
//       >
//         <h3 style={{ fontSize: '1.6rem', fontWeight: '700', marginBottom: '1rem' }}>All Posts</h3>
//         {posts.length === 0 ? (
//           <p>No posts yet. Be the first to create one!</p>
//         ) : (
//           posts.map((post) => (
//             <div
//               key={post._id}
//               style={{
//                 display: 'flex',
//                 gap: '1rem',
//                 border: '1px solid #e0e0e0',
//                 borderRadius: '8px',
//                 padding: '1rem',
//                 marginBottom: '1.5rem',
//                 backgroundColor: '#fff',
//                 alignItems: 'flex-start'
//               }}
//             >
//               {/* Small media preview */}
//               {post.mediaUrl && post.mediaType.startsWith('image') && (
//                 <img
//                   src={post.mediaUrl}
//                   alt="Post media"
//                   style={{
//                     width: '100px',
//                     height: '100px',
//                     objectFit: 'cover',
//                     borderRadius: '6px',
//                     flexShrink: 0
//                   }}
//                 />
//               )}

//               {post.mediaUrl && post.mediaType.startsWith('video') && (
//                 <video
//                   controls
//                   style={{
//                     width: '100px',
//                     height: '100px',
//                     objectFit: 'cover',
//                     borderRadius: '6px',
//                     flexShrink: 0
//                   }}
//                 >
//                   <source src={post.mediaUrl} type={post.mediaType} />
//                 </video>
//               )}

//               {/* Post content */}
//               <div style={{ flex: 1 }}>
//                 <h4 style={{ fontSize: '1.2rem', marginBottom: '0.5rem' }}>{post.title}</h4>
//                 <p style={{ fontSize: '0.95rem', color: '#444', marginBottom: '0.5rem' }}>
//                   {post.content.substring(0, 150)}...
//                 </p>

//                 {/* Auto bot comment */}
//                 {botResponses[post._id] && (
//                   <div
//                     style={{
//                       marginBottom: '0.75rem',
//                       padding: '0.5rem',
//                       backgroundColor: '#f1f7ff',
//                       borderRadius: '6px',
//                       border: '1px solid #cce0ff'
//                     }}
//                   >
//                     <strong style={{ fontSize: '0.85rem' }}>🤖 TJG Bot:</strong>
//                     <p style={{ marginTop: '0.25rem', fontSize: '0.85rem' }}>
//                       {botResponses[post._id]}
//                     </p>
//                   </div>
//                 )}

//                 <button
//                   onClick={() => onSelectPost(post._id)}
//                   style={{
//                     padding: '0.4rem 0.8rem',
//                     backgroundColor: '#0a66c2',
//                     color: '#fff',
//                     border: 'none',
//                     borderRadius: '4px',
//                     cursor: 'pointer',
//                     fontSize: '0.85rem'
//                   }}
//                 >
//                   View Post
//                 </button>
//               </div>
//             </div>
//           ))
//         )}
//       </div>
//     </div>
//   );
// }

// export default PostList;






// import React from 'react';

// function PostList({ posts, onSelectPost }) {
//   return (
//     <div
//       style={{
//         backgroundColor: '#f3f6f8',
//         minHeight: '100vh',
//         padding: '2rem 0',
//         display: 'flex',
//         justifyContent: 'center'
//       }}
//     >
//       <div
//         style={{
//           width: '100%',
//           maxWidth: '700px',
//           backgroundColor: '#ffffff',
//           padding: '2rem',
//           borderRadius: '12px',
//           boxShadow: '0 4px 8px rgba(0,0,0,0.05)'
//         }}
//       >
//         <h3 style={{ fontSize: '1.6rem', fontWeight: '700', marginBottom: '1rem' }}>All Posts</h3>
//         {posts.length === 0 ? (
//           <p>No posts yet. Be the first to create one!</p>
//         ) : (
//           posts.map((post) => (
//             <div
//               key={post._id}
//               style={{
//                 border: '1px solid #e0e0e0',
//                 borderRadius: '8px',
//                 padding: '1rem',
//                 marginBottom: '1.5rem',
//                 backgroundColor: '#fff'
//               }}
//             >
//               <h4 style={{ fontSize: '1.2rem', marginBottom: '0.5rem' }}>{post.title}</h4>

//               {post.mediaUrl && post.mediaType.startsWith('image') && (
//                 <img
//                   src={post.mediaUrl}
//                   alt="Post media"
//                   style={{
//                     width: '100%',
//                     maxHeight: '200px',
//                     objectFit: 'cover',
//                     borderRadius: '6px',
//                     marginBottom: '0.75rem'
//                   }}
//                 />
//               )}

//               {post.mediaUrl && post.mediaType.startsWith('video') && (
//                 <video
//                   controls
//                   style={{
//                     width: '100%',
//                     maxHeight: '200px',
//                     objectFit: 'cover',
//                     borderRadius: '6px',
//                     marginBottom: '0.75rem'
//                   }}
//                 >
//                   <source src={post.mediaUrl} type={post.mediaType} />
//                 </video>
//               )}

//               <p style={{ fontSize: '0.95rem', color: '#444' }}>{post.content.substring(0, 150)}...</p>

//               <button
//                 onClick={() => onSelectPost(post._id)}
//                 style={{
//                   marginTop: '0.75rem',
//                   padding: '0.5rem 1rem',
//                   backgroundColor: '#0a66c2',
//                   color: '#fff',
//                   border: 'none',
//                   borderRadius: '4px',
//                   cursor: 'pointer',
//                   fontSize: '0.9rem'
//                 }}
//               >
//                 View Post
//               </button>
//             </div>
//           ))
//         )}
//       </div>
//     </div>
//   );
// }

// export default PostList;







// function PostList({ posts, onSelectPost }) {
//   return (
//     <div>
//       <h3>All Posts</h3>
//       {posts.length === 0 ? (
//         <p>No posts yet. Be the first to create one!</p>
//       ) : (
//         posts.map((post) => (
//           <div key={post._id} style={{ border: '1px solid #ccc', padding: '0.5rem', marginBottom: '1rem' }}>
//             <h4>{post.title}</h4>
//             {post.mediaUrl && post.mediaType.startsWith('image') && (
//               <img src={post.mediaUrl} alt="thumbnail" style={{ width: "100px", height: "auto" }} />
//             )}
//             <p>{post.content.substring(0, 100)}...</p>
//             <button onClick={() => onSelectPost(post._id)}>View</button>
//           </div>
//         ))
//       )}
//     </div>
//   );
// }

// export default PostList;
